import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ReactComponent as ChevronLeft } from '../svg/chevron-left.svg';
import { getAllUsers } from './Users';
import Loading from '../components/Loading';
import ProviderForm from '../components/ProviderForm';
import Layout from './Layout';
import { getVendors } from '../slices/sessionSlice';

export const getProvider = (providerid) => {
    return axios
        .request({
            url: `${process.env.REACT_APP_API_URL}/authorized/providers/${providerid}`,
            method: 'GET'
        })
        .then((resp) => resp.data);
};

export const updateProvider = (providerid, data = {}) => {
    return axios
        .request({
            url: `${process.env.REACT_APP_API_URL}/authorized/providers/${providerid}`,
            method: 'PATCH',
            data
        })
        .then((resp) => resp.data);
};

const ProviderEdit = ({ match = {} }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [provider, setProvider] = useState({});
    const [success, setSuccess] = useState(null);
    const [users, setUsers] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [vendors, setVendors] = useState([]);

    useEffect(() => {
        Promise.all([
            getAllUsers({
                provider_id: match.params.providerid
            }),
            getProvider(match.params.providerid)
        ]).then(async ([users, provider]) => {
            let vendors = await loadVendors(provider);
            setUsers(users.results);
            setProvider(provider);
            setVendors(vendors);
            setIsLoading(false);
        });
    }, [match.params.providerid]);

    const loadVendors = async (provider) => {
        let resp = provider.vendors.map((v) => ({ name: 'Unknown', ...v }));
        try {
            resp = await getVendors(provider.vendors);
        } catch (e) {
            console.error(e);
        }
        return resp;
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        setSubmitting(true);
        try {
            let provider = await updateProvider(match.params.providerid, {
                name: values.name,
                vendors: values.vendors.filter((v) => v.findawayvendorid),
                publishers: values.publishers.filter((v) => v),
                singletitleupload: values.singletitleupload
            });

            let vendors = await loadVendors(provider);
            toast.success('Provider Updates Saved');
            setSubmitting(false);
            setSuccess(true);
            setIsEditing(false);
            setProvider(provider);
            setVendors(vendors);
        } catch (e) {
            toast.error('Provider could not be added, please try again.');
            setSubmitting(false);
            setSuccess(null);
        }
    };

    return (
        <Layout>
            {isLoading && <Loading />}
            {!isLoading && (
                <>
                    <p>
                        <Link className="alt-link" to="/providers">
                            <ChevronLeft width="1em" height="1em" />
                            Back to Providers
                        </Link>
                    </p>
                    <div className="page-header">
                        <h1>{provider.name}</h1>
                    </div>

                    {!isEditing && (
                        <div className="mb-5">
                            <p>
                                <strong>Publishers:</strong> {provider?.publishers?.join(', ')}
                            </p>
                            <div className="mb-3">
                                <strong>Vendors:</strong>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>NS Vendor ID</th>
                                            <th>Tipalti ID</th>
                                            <th>Royalty Record ID</th>
                                            <th>Spotify Licensor ID</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {vendors.map((vendor) => (
                                            <tr key={vendor.findawayvendorid}>
                                                <td>{vendor.vendorname}</td>
                                                <td>{vendor.findawayvendorid}</td>
                                                <td>{vendor.tipaltipayeeid}</td>
                                                <td>{vendor.royaltyrecordid}</td>
                                                <td>{vendor.spotify_licensor_id}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <ul className="list-flat"></ul>
                            </div>
                            <button className="btn btn-sm" onClick={() => setIsEditing(true)}>
                                Edit Provider
                            </button>
                        </div>
                    )}

                    {isEditing && (
                        <div className="row mb-5">
                            <ProviderForm
                                initalValues={{
                                    name: provider.name,
                                    publishers: provider.publishers,
                                    vendors: provider.vendors,
                                    singletitleupload: provider.singletitleupload
                                }}
                                onSubmit={handleSubmit}
                                onCancel={(e) => {
                                    e.preventDefault();
                                    setIsEditing(false);
                                }}
                                success={success}
                            />
                        </div>
                    )}

                    <div>
                        <h2>Users</h2>

                        <ul className="list-flat">
                            {users.map((user) => (
                                <li key={user.username}>
                                    <Link to={`/users/${user.username}`}>
                                        {user.firstname || 'Unknown'} {user.lastname || 'Unknown'} - {user.email}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </>
            )}
        </Layout>
    );
};

export default ProviderEdit;
